import { useState } from "react";

function UploadButton({
  warpedImage,
  vehicleID,
  name,
  createdBy,
  disabled,
  onUploadSuccess,
  savedHost,
}) {
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const handleUpload = async () => {
    // Validate required fields
    if (vehicleID === null || vehicleID === undefined) {
      alert(
        "Fehler: Keine Fahrzeug-ID erkannt. Bitte scannen Sie den Marker erneut.",
      );
      return;
    }

    if (!name || name.trim() === "") {
      alert("Fehler: Bitte geben Sie einen Namen ein.");
      return;
    }

    setIsUploading(true);

    try {
      // Convert base64 to blob
      const base64Response = await fetch(warpedImage);
      const blob = await base64Response.blob();

      // Create a File object from the blob
      const file = new File([blob], `scanned-document-${Date.now()}.png`, {
        type: "image/png",
        lastModified: Date.now(),
      });

      // Create FormData
      const formData = new FormData();
      formData.append("file", file);
      formData.append("vehicleId", String(vehicleID));
      formData.append("name", name.trim());

      // Add uploader if provided
      if (createdBy && createdBy.trim() !== "") {
        formData.append("uploader", createdBy.trim());
      }

      // Send to backend
      const uploadResponse = await fetch(`${savedHost}/api/upload`, {
        method: "POST",
        body: formData,
        credentials: "include",
      });

      if (uploadResponse.ok) {
        const responseData = await uploadResponse.json();

        // Show success checkmark
        setUploadSuccess(true);

        // Wait 4 seconds before resetting
        setTimeout(() => {
          setUploadSuccess(false);
          if (onUploadSuccess) {
            onUploadSuccess();
          }
        }, 4000);
      } else {
        let userMessage = "Fehler beim Senden des Bildes.";
        try {
          const errorData = await uploadResponse.json();
          if (errorData?.error) {
            userMessage = errorData.error;
          }
        } catch {
          // Response ist kein JSON, generische Meldung behalten
        }
        throw new Error(userMessage);
      }
    } catch (error) {
      console.error("Error sending to backend:", error);
      alert(error.message || "Fehler beim Senden des Bildes.");
    } finally {
      setIsUploading(false);
    }
  };

  const isDisabled = disabled || !name || name.trim() === "" || isUploading;

  return (
    <div className="upload-button-container">
      {uploadSuccess ? (
        <button disabled className="upload-button upload-button-success">
          ✓ Erfolgreich gesendet!
        </button>
      ) : (
        <button
          onClick={handleUpload}
          disabled={isDisabled}
          className={`upload-button ${
            isDisabled ? "upload-button-disabled" : "upload-button-primary"
          }`}
        >
          {isUploading ? "Bitte warten..." : "Fertigstellen"}
        </button>
      )}
    </div>
  );
}

export default UploadButton;
